var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TextArea',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"hide-details":"","rules":_vm.rules},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }